export default {"src":"/_next/static/media/contact-us.b4a91ca2.svg","height":500,"width":500};